module.exports = __webpack_public_path__ + "media/icons/file-download-f9f99fc7.png";